<template>
  <div class="header">
    <div class="logo">
      <a href="/">
        <img src="../assets/logo-24px.svg" />
      </a>
    </div>
    <div class="menu">
      <el-menu :default-active="activeIndex" mode="horizontal" @select="handleSelect" :router="true">
        <el-menu-item index="/DOC" route="/DOC">DOC</el-menu-item>
        <el-menu-item index="/API" route="/API">API</el-menu-item>
        <!-- <el-submenu index="/API/380">
          <template slot="title"><span @click="apitTitle" class="apitTitle">API</span></template>
          <el-menu-item index="/API/382" route="/API/382">V3.8.2 (future)</el-menu-item>
          <el-menu-item index="/API/380" route="/API/380">V3.8.0 (Beta)</el-menu-item>
          <el-menu-item index="/API/372" route="/API/372">V3.7.2 (current)</el-menu-item>
          <el-menu-item index="/API/370" route="/API/370">V3.7.0 (previous)</el-menu-item>
        </el-submenu> -->
        <!-- <el-menu-item index="/development" route="/API">API</el-menu-item> -->
         <!-- <el-menu-item index="/helpCenter" route="/HELP">{{ $t("lang.helpCenter") }}</el-menu-item> -->
      </el-menu>
    </div>
    <div class="language">
      <div class="image">
        <img src="../assets/ic_language.svg" style="margin-bottom: -2px" />
      </div>
      <el-dropdown trigger="click" placement="bottom-start" @command="handleCommand">
        <span class="el-dropdown-link">
          {{ language }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="zh" class="el-dropdown-item-lang">中文</el-dropdown-item>
          <el-dropdown-item command="en" class="el-dropdown-item-lang">English</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { getCookie, setCookie, getLang } from "../common/utils";

export default {
  inject: ['reload'],
  data() {
    return {
      activeIndex: "",
      isDomestic: false,
      custom: "",
      language: "",
    };
  },
  mounted() {
    this.activeIndex = this.$router.history.current.path;
    const lang = getLang();
    if (lang === "en-US") {
      this.language = "English";
    } else {
      this.language = "中文";
    }
    this.custom = getCookie("custom");
  },
  methods: {
    apitTitle() {
      this.$router.push({path: '/API/372'})
      this.reload();
    },
    handleSelect(key) {
      this.activeIndex = key;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      if (key.indexOf("/API") !== -1 && this.$router.history.current.path.indexOf("/API") !== -1) {
          this.reload();
      }
    },
    handleCommand(command) {
      if (command === "zh") {
        // this.$i18n.locale = 'zh-CN';
        // this.language = "中文";
        setCookie("lang", "zh-CN");
      } else {
        // this.$i18n.locale = 'en-US';
        // this.language = "English";
        setCookie("lang", "en-US");
      }
      location.reload();
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  position: sticky;
  height: 65px;
  top: 0;
  background: #2b303b;
  color: white;
  z-index: 9999;
  box-shadow: 0 3px 8px 0 rgba(116, 129, 141, 0.1);

  .logo {
    width: 50px;
    float: left;
    margin: 10px 160px 10px 50px;

    a {
      img {
        width: 160px;
        height: 40px;
      }
    }
  }

  .menu {
    display: inline-block;
    width: 50%;
    .apitTitle {
      display: inline-block;
      height: 65px;
    }
  }

  .language {
    position: absolute;
    right: 40px;
    top: 23px;
    color: #000;
    cursor: pointer;
    .image {
      display: inline-block;
      margin-right: 10px;
    }

    .el-dropdown {
      color: white;
    }
  }

  .el-menu {
    background-color: transparent;
    border: none;
  }

  .el-menu--horizontal>.el-menu-item {
    height: 65px;
    line-height: 65px;
    color: white;
    font-size: 16px;
  }

  .el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: 3px solid #597ef7;
    color: #597ef7;
  }

  .el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
  .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
    background-color: transparent;
    color: white;
  }
  .el-link {
    font-size: 16px;
  }
}
</style>
